import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DateAdapter, MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AgentIdMaster, Gameratemaster, UserMaster } from '../AllModels';
import { addUserMasterURL, updateLineMasterURL, getByIdUserMasterURL, getAllUserMasterURL, checkMobileNumberURL, saveGameRateMasterURL, updateGameRateMasterURL, getAllGameRateURL, getByIdGameRateURl, getActiveAgentURL, getGameRateListByAgentId } from '../AllURL';
import { HttpmethodsService } from '../shared/service/httpmethods.service';

@Component({
  selector: 'app-gameratemaster',
  templateUrl: './gameratemaster.component.html',
  styleUrls: ['./gameratemaster.component.css']
})
export class GameratemasterComponent implements OnInit {


  gameratemasterForm: FormGroup;
  GameratemasterModel = new Gameratemaster();
  isEdit: boolean = true;
  hide = true;
  mobileMsg: string;
  mobFlag: boolean = false;
  textColorMobile: string;
  ActiveAgentList:Array<Gameratemaster>;
  agentId: number;

  constructor(private formBuilder: FormBuilder, public toastr: ToastrManager, private httpService: HttpmethodsService, private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('en-GB');
  }

  displayedColumns: string[] = ['Sr.No.', 'User Name', 'Game Rate','status', 'Action'];
  dataSource = new MatTableDataSource<Gameratemaster>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('epltable', { static: false }) epltable: ElementRef;

  ngOnInit() {
    this.gameratemasterForm = this.formBuilder.group({
      gamename: new FormControl('', [Validators.required,]),
      gamerate: new FormControl('', [Validators.required]),
      status: new FormControl('', [Validators.required]),
      agentId:new FormControl('', [Validators.required]),
      agentId1:new FormControl('', []),
    })
    this.getAllUser();
    this.getActiveAgent();
    this.hide = true;
  }

  

    getActiveAgent() {
      this.httpService.getRequest(getActiveAgentURL).subscribe((data: any) => {
        this.ActiveAgentList = data;
      })
    }

  SaveUser() {
    if (this.isEdit) {
        this.httpService.postRequest(saveGameRateMasterURL, this.GameratemasterModel).subscribe((data: any) => {
          if (data) {
            this.isEdit = true;
            this.toastr.successToastr('Save Successfully...!', 'Success!', { timeout: 500 });
            this.getAllUser();
            this.gameratemasterForm.reset();
            this.mobileMsg=" ";
            
          }
          else {
            this.toastr.errorToastr("Something went Wrong.", "Error");
          }
        })
    }
    else {
        this.httpService.putRequest(updateGameRateMasterURL, this.GameratemasterModel).subscribe((data: any) => {
          if (data) {
            this.isEdit = true;
            this.toastr.successToastr('Update Successfully...!', 'Success!', { timeout: 500 });
            this.getAllUser();
            this.gameratemasterForm.reset();
            this.mobileMsg=" ";
          }
          else {
            this.toastr.errorToastr("Something went Wrong.", "Error");
          }
        })
   
    }  
  }

  getUserById(gameRateMasterId) {
    this.httpService.getRequest(getByIdGameRateURl + "/" + gameRateMasterId).subscribe((data: any) => {
      this.GameratemasterModel = data;
      this.isEdit = false;
      const element = document.querySelector('#scrollId');
      element.scrollIntoView();
    })
  }

  getAllUser() {

    this.httpService.getRequest(getGameRateListByAgentId + "/" + sessionStorage.getItem("agentId")).subscribe((data: any) => {
      if (data) {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
      }
      else {
        this.toastr.errorToastr("No Records Found.", "Error");
      }
    })
  }


  
  getGameRateListByAgentId()
  {
    this.httpService.getRequest(getGameRateListByAgentId + "/" + this.GameratemasterModel.agentId1).subscribe((data: any) => {
      if (data) {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
      }
      else {
        this.toastr.errorToastr("No Records Found.", "Error");
      }
    })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
